import React, { useContext, useState } from 'react'
import { AllStarOuterCon, PlayerTypeTabs } from '../styles'
import { PlayerAllStarType } from '../../../Api'
import { AllStarContext } from '../../../Context'
import { SaveCon } from './saveCon/'
import { AllStarContainer } from './AllStarContainer'
import { asgTeams } from '../../../Constants/allStar'
import { PanelCon } from '../../AllStarGame/styles'
import { Tab } from '../../../Components/LazyComponents'

export const AllStarOuter: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { handlePlayerTypeChange, playerType } = useContext(AllStarContext)!
  const [value, setValue] = useState<number>(0)

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue)
    const playerType: PlayerAllStarType = newValue === 0 ? 'east' : 'west'
    handlePlayerTypeChange(playerType)
  }

  return (
    <>
      <SaveCon />
      <AllStarOuterCon>
        <PlayerTypeTabs
          value={value}
          onChange={handleChange}
          aria-label="asg player tabs"
          variant="fullWidth"
          playertype={playerType}
        >
          {asgTeams.map((t) => (
            <Tab label={t.name} key={t.id} />
          ))}
        </PlayerTypeTabs>
        {asgTeams.map((t, idx) => (
          <PanelCon key={idx} value={value} index={idx} borderRadius={4} marginTop={4}>
            <AllStarContainer />
          </PanelCon>
        ))}
      </AllStarOuterCon>
    </>
  )
}
